// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"style_buttonsContainer__2zmFo","buttonsContainerCol":"style_buttonsContainerCol__SN-yK"};